module.exports = __webpack_public_path__ + "static/media/chanelallureforher.df5b9886.png";